<template>
  <div class="equity-chart" ref="container">
    <div class="toolbar">
      <div class="toolbar-left">
        <span class="toolbar-title">股权穿透图</span>
        <span class="toolbar-divider">|</span>
        <span class="toolbar-company">{{ centerNode.name }}</span>
      </div>
    </div>

    <div class="legend-panel">
      <div class="legend-row"><span class="legend-dot current"></span><span>当前节点</span></div>
      <div class="legend-row"><span class="legend-dot company"></span><span>企业</span></div>
      <div class="legend-row"><span class="legend-dot person"></span><span>人员</span></div>
      <div class="legend-row"><span class="legend-line"></span><span>投资</span></div>
    </div>

    <div class="canvas-area" ref="canvasArea">
      <svg ref="svg" class="main-svg" :width="canvasWidth" :height="canvasHeight">
        <defs></defs>
        <g ref="mainGroup" :transform="`translate(${translateX},${translateY}) scale(${currentZoom})`">
          <g class="links-layer"></g>
          <g class="controller-tag-layer"></g>
          <g class="nodes-layer"></g>
        </g>
      </svg>
    </div>

    <transition name="card-fade">
      <div v-if="centerHover" class="center-card" :style="centerCardStyle" ref="centerCard"
        @mouseenter="onCenterCardEnter" @mouseleave="onCenterCardLeave">
        <div class="center-card-header">
          <div class="center-logo">{{ centerNode.name.substring(0, 3) }}</div>
          <div class="center-info">
            <div class="center-name" :class="centerNode.stockCode!=''?'color-blue':''" @click="linkEnterpriseDetail(rawData)">{{ centerNode.name }}</div>
            <div class="center-status">存续</div>
          </div>
        </div>
        <div class="center-card-body">
          <div class="center-tags">
            <span v-if="rawData.stockCode" class="tag blue">{{ rawData.stockCode }}</span>
          </div>
          <div class="center-detail">
            <div class="detail-row" v-if="rawData.legalPerson"><span class="detail-label">法定代表人</span><span
                class="detail-value blue">{{ rawData.legalPerson }}</span></div>
            <div class="detail-row" v-if="rawData.regCapital"><span class="detail-label">注册资本</span><span
                class="detail-value">{{ rawData.regCapital }}</span></div>
            <div class="detail-row" v-if="rawData.creditCode"><span class="detail-label">统一信用代码</span><span
                class="detail-value">{{ rawData.creditCode }}</span></div>
            <div class="detail-row" v-if="rawData.actualController"><span class="detail-label">实际控制人</span><span
                class="detail-value">{{ rawData.actualController }}</span></div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="card-fade">
      <div v-if="hoverNode && !centerHover" class="hover-card" :style="cardStyle" ref="hoverCard"
        @mouseenter="onCardEnter" @mouseleave="onCardLeave">
        <div class="card-head">
          <div class="card-avatar" :class="hoverNode.type">{{ hoverNode.name.charAt(0) }}</div>
          <div class="card-info">
            <div class="card-name" :class="hoverNode.stockCode!=''?'color-blue':''" @click="linkEnterpriseDetail(hoverNode)">{{ hoverNode.name }}</div>
            <div class="card-badge" :class="hoverNode.type">{{ hoverNode.type === 'person' ? '自然人' : '企业' }}</div>
          </div>
        </div>
        <div class="card-content">
          <div class="info-row" v-if="hoverNode.ratio !== undefined && hoverNode.ratio !== null"><span
              class="info-label">持股比例</span><span class="info-value orange">{{ hoverNode.ratio }}%</span></div>
          <div class="info-row" v-if="hoverNode.amount"><span class="info-label">认缴金额</span><span class="info-value">{{
            hoverNode.amount }}</span></div>
          <div class="info-row" v-if="hoverNode.stockCode"><span class="info-label">股票代码</span><span
              class="info-value">{{ hoverNode.stockCode }}</span></div>
          <div class="info-row" v-if="hoverNode.creditCode"><span class="info-label">统一信用代码</span><span
              class="info-value">{{ hoverNode.creditCode }}</span></div>
          <div class="info-row" v-if="hoverNode.legalPerson"><span class="info-label">法定代表人</span><span
              class="info-value">{{ hoverNode.legalPerson }}</span></div>
          <div class="info-row" v-if="hoverNode.regCapital"><span class="info-label">注册资本</span><span
              class="info-value">{{ hoverNode.regCapital }}</span></div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import * as d3 from 'd3'
import { getEquityData } from '@/api/cyl.js'
export default {
  name: 'EquityChart',
  data() {
    return {
      canvasWidth: 0, canvasHeight: 0,
      translateX: 0, translateY: 0, currentZoom: 1,
      hoverNode: null, centerHover: false,
      cardStyle: {}, centerCardStyle: {},
      centerNode: { name: '加载中...' },
      rawData: null,
      config: {
        nodeWidth: 170, nodeHeight: 56,
        centerNodeWidth: 350, centerNodeHeight: 44,
        levelGap: 160, nodeGap: 20,
      },
      rootOfDown: null, rootOfUp: null,
      tree: null, gLinks: null, gNodes: null, gControllerTag: null,
      duration: 500,
      hideCardTimer: null,
      hideCenterCardTimer: null,
      showCardTimer: null,
      showCenterCardTimer: null,
      _pendingShowDetail: null,
      _pendingShowCenter: false,
      _fetchingNodes: new Set(),
    }
  },
  props: {
    reuqestData: {
      type: Object,
      default: () => ({}),
    }
  },
  mounted() {
    this.initData()
    this.$nextTick(() => {
      this.initCanvas()
      this.setupZoom()
    })
    window.addEventListener('resize', this.handleResize)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize)
    clearTimeout(this.hideCardTimer)
    clearTimeout(this.hideCenterCardTimer)
    clearTimeout(this.showCardTimer)
    clearTimeout(this.showCenterCardTimer)
  },
  methods: {
    linkEnterpriseDetail(node) {
      console.log('linkEnterpriseDetail', node)
      if (node.stockCode=='') return;
      let loginToken =  window.btoa(localStorage.getItem('token'));
      let loginRefer =   window.btoa('/enterprises?id='+ node.stockCode);
      // return
      window.open(`https://zhaoshangdanao.com/#/user-login?token=${loginToken}&refer=${loginRefer}`, '_blank');
    },

    // ========== 数据转换 ==========
    transformData(raw) {
      if (!raw) return null
      const result = {
        name: raw.title || raw.name || '',
        type: 'center',
        stockCode: raw.stockCode || '',
        creditCode: raw.creditCode || '',
        legalPerson: raw.legalPerson || '',
        regCapital: raw.regCapital || '',
        actualController: raw.actualController || '',
      }
      if (raw.childList && raw.childList.length > 0) {
        result.childList = this.transformDownNodes(raw.childList)
      }
      if (raw.parentList && raw.parentList.length > 0) {
        result.parents = this.transformUpNodes(raw.parentList)
      }
      return result
    },

    transformDownNodes(list) {
      if (!list || !Array.isArray(list)) return undefined
      return list.map(item => {
        const node = {
          name: item.title || '',
          type: item.creditCode || item.stockCode ? 'company' : [...item.title || item.name].length > 5 ? 'company' : 'person',
          ratio: this.parseRatio(item.ratio),
          tag: item.tag || '',
          amount: item.amount || '',
          stockCode: item.stockCode || '',
          creditCode: item.creditCode || '',
          legalPerson: item.legalPerson || '',
          regCapital: item.regCapital || '',
          canExpandChild: item.child === true,
        }
        if (item.childList && item.childList.length > 0) {
          node.childList = this.transformDownNodes(item.childList)
        }
        return node
      })
    },

    transformUpNodes(list) {
      if (!list || !Array.isArray(list)) return undefined
      return list.map(item => {
        const node = {
          name: item.title || item.name || '',
          type: item.creditCode || item.stockCode ? 'company' : [...item.title || item.name].length > 5 ? 'company' : 'person',
          ratio: this.parseRatio(item.ratio),
          tag: item.tag || '',
          amount: item.amount || '',
          stockCode: item.stockCode || '',
          creditCode: item.creditCode || '',
          legalPerson: item.legalPerson || '',
          regCapital: item.regCapital || '',
          isController: item.isController || false,
          canExpandParent: item.parent === true,
        }
        if (item.parentList && item.parentList.length > 0) {
          node.parents = this.transformUpNodes(item.parentList)
        }
        return node
      })
    },

    parseRatio(val) {
      if (val === undefined || val === null) return undefined
      if (typeof val === 'number') return val
      if (typeof val === 'string') return parseFloat(val.replace('%', ''))
      return undefined
    },

    initData() {
      getEquityData(this.reuqestData).then(res => {
        this.rawData = this.transformData(res)
        this.centerNode.name = this.rawData.name;
        document.title = this.rawData.name +'-股权穿透图';
        this.$nextTick(() => {
          this.initCanvas()
          this.drawChart()
        })
      })
    },

    initCanvas() {
      const area = this.$refs.canvasArea
      if (!area) return
      this.canvasWidth = area.clientWidth
      this.canvasHeight = area.clientHeight
      this.translateX = this.canvasWidth / 2
      this.translateY = this.canvasHeight / 2
    },

    drawChart() {
      if (!this.rawData) return
      const mainGroup = d3.select(this.$refs.mainGroup)
      mainGroup.selectAll('*').remove()
      this.gLinks = mainGroup.append('g').attr('class', 'links-layer')
      this.gControllerTag = mainGroup.append('g').attr('class', 'controller-tag-layer')
      this.gNodes = mainGroup.append('g').attr('class', 'nodes-layer')

      this.tree = d3.tree().nodeSize([this.config.nodeWidth + this.config.nodeGap, this.config.levelGap])
      this.rootOfDown = d3.hierarchy(this.rawData, d => d.childList)
      this.rootOfUp = d3.hierarchy(this.rawData, d => d.parents)

      ;[this.rootOfDown, this.rootOfUp].forEach(root => {
        root.descendants().forEach(node => {
          if (node.children) {
            node._children = node.children
            if (node.depth > 0) node.children = null
          }
        })
      })

      this.rootOfDown.x0 = 0; this.rootOfDown.y0 = 0
      this.rootOfUp.x0 = 0; this.rootOfUp.y0 = 0
      this.update(null)
    },

    update(source) {
      if (!source) source = { x0: 0, y0: 0 }
      this.tree(this.rootOfDown)
      this.tree(this.rootOfUp)

      const nodesOfDown = this.rootOfDown.descendants().reverse()
      const linksOfDown = this.rootOfDown.links()
      const nodesOfUp = this.rootOfUp.descendants().reverse()
      const linksOfUp = this.rootOfUp.links()
      nodesOfUp.forEach(node => { node.y = -node.y })

      const t = d3.transition().duration(this.duration).ease(d3.easeCubicOut)
      this.drawTree(nodesOfDown, linksOfDown, 'down', source, t)
      this.drawTree(nodesOfUp, linksOfUp, 'up', source, t)

      this.rootOfDown.eachBefore(d => { d.x0 = d.x; d.y0 = d.y })
      this.rootOfUp.eachBefore(d => { d.x0 = d.x; d.y0 = d.y })
      this.updateAllExpandBtnSymbols()
      this.updateControllerTag()
    },

    getLinkOffset(node, isSource) {
      if (!node || !node.data) return 0
      const isCenter = node.depth === 0
      const h = isCenter ? this.config.centerNodeHeight : this.config.nodeHeight
      let offset = h / 2
      if (isSource) {
        const hasBtn = node._children
          || (node.children && node.children.length > 0)
          || node.data.canExpandParent
          || node.data.canExpandChild
        if (hasBtn) offset += isCenter ? 24 : 21
      }
      return offset
    },

    drawLink(d) {
      if (!d || !d.source || !d.target) return ''
      const sOff = this.getLinkOffset(d.source, true)
      const tOff = this.getLinkOffset(d.target, false)
      let sy, ty
      if (d.source.y < d.target.y) {
        sy = d.source.y + sOff; ty = d.target.y - tOff
      } else {
        sy = d.source.y - sOff; ty = d.target.y + tOff
      }
      const sx = d.source.x, tx = d.target.x
      if (Math.abs(sy - ty) < 1) return `M${sx},${sy} L${tx},${ty}`
      const halfY = (sy + ty) / 2
      return `M${sx},${sy} L${sx},${halfY} L${tx},${halfY} L${tx},${ty}`
    },

    drawTree(nodes, links, direction, source, transition) {
      const isUp = direction === 'up'
      const className = isUp ? 'nodeOfUp' : 'nodeOfDown'
      const vm = this
      const dummy = { depth: -1, _children: null, children: null, data: {} }

      const node = this.gNodes.selectAll(`g.${className}ItemGroup`)
        .data(nodes, d => d.data.id || d.data.name)

      const nodeEnter = node.enter().append('g')
        .attr('class', `${className}ItemGroup`)
        .attr('transform', d => `translate(${source.x0 || 0},${source.y0 || 0})`)
        .attr('fill-opacity', 0).attr('stroke-opacity', 0).style('cursor', 'pointer')

      this.drawNodeContent(nodeEnter, isUp)

      node.merge(nodeEnter).transition(transition)
        .attr('transform', d => `translate(${d.x},${d.y})`)
        .attr('fill-opacity', 1).attr('stroke-opacity', 1)

      node.exit().transition(transition).remove()
        .attr('transform', d => `translate(${source.x || 0},${source.y || 0})`)
        .attr('fill-opacity', 0).attr('stroke-opacity', 0)

      const link = this.gLinks.selectAll(`path.${className}Link`)
        .data(links, d => d.target.data.id || d.target.data.name)

      const linkEnter = link.enter().append('path')
        .attr('class', `${className}Link`)
        .attr('d', () => {
          const o = { source: { ...dummy, x: source.x0 || 0, y: source.y0 || 0 }, target: { ...dummy, x: source.x0 || 0, y: source.y0 || 0 } }
          return this.drawLink(o)
        })
        .attr('fill', 'none').attr('stroke', '#b0c4de').attr('stroke-width', 1.5)

      link.merge(linkEnter).transition(transition).attr('d', d => this.drawLink(d))

      link.exit().transition(transition).remove()
        .attr('d', () => {
          const o = { source: { ...dummy, x: source.x || 0, y: source.y || 0 }, target: { ...dummy, x: source.x || 0, y: source.y || 0 } }
          return this.drawLink(o)
        })
    },

    updateControllerTag() {
      const g = this.gControllerTag
      g.selectAll('*').remove()
      if (!this.rootOfUp.children) return

      const controllerNode = this.rootOfUp.descendants().find(d => d.data.isController)
      if (!controllerNode) return

      const sOff = this.getLinkOffset(controllerNode, true)
      const tOff = this.getLinkOffset(this.rootOfUp, false)

      let sy = controllerNode.y + sOff
      let ty = this.rootOfUp.y - tOff
      const sx = controllerNode.x
      const halfY = (sy + ty) / 2
      const midY = (sy + halfY) / 2

      const tagG = g.append('g').attr('transform', `translate(${sx}, ${midY})`)

      tagG.append('polygon').attr('points', '0,0 -5,-6 5,-6').attr('fill', '#ff4d4f')
      tagG.append('rect').attr('x', -48).attr('y', -28).attr('width', 96).attr('height', 22).attr('rx', 4).attr('fill', '#ff4d4f')
      tagG.append('text').attr('x', 0).attr('y', -17).attr('text-anchor', 'middle').attr('dominant-baseline', 'middle')
        .attr('fill', 'rgba(255,255,255,0.9)').attr('font-size', '10px').text('实际控制人')

      const bottomText = `${controllerNode.data.name} 受益所有人:${controllerNode.data.ratio}%`
      tagG.append('rect').attr('x', -60).attr('y', -6).attr('width', 120).attr('height', 20).attr('rx', 4).attr('fill', '#ff4d4f')
      tagG.append('text').attr('x', 0).attr('y', 4).attr('text-anchor', 'middle').attr('dominant-baseline', 'middle')
        .attr('fill', '#fff').attr('font-size', '10px').attr('font-weight', '600').text(bottomText)
    },

    drawNodeContent(selection, isUp) {
      const cfg = this.config
      const vm = this

      selection.each((d, i, nodes) => {
        const g = d3.select(nodes[i])
        const isCenter = d.depth === 0
        const isPerson = d.data.type === 'person'
        const w = isCenter ? cfg.centerNodeWidth : cfg.nodeWidth
        const h = isCenter ? cfg.centerNodeHeight : cfg.nodeHeight
        const rx = isPerson ? h / 2 : 4

        // ======== 中心节点 ========
        if (isCenter) {
          // 事件绑定在 g 上，避免移到内部子元素时触发 leave
          g.on('mouseenter', (e) => vm.showCenterDetail(e))
           .on('mouseleave', () => vm.hideCenterDetail())

          g.append('rect').attr('x', -w / 2).attr('y', -h / 2).attr('width', w).attr('height', h)
            .attr('rx', rx).attr('fill', '#1890ff')

          g.append('text').attr('text-anchor', 'middle').attr('dominant-baseline', 'middle')
            .attr('fill', '#fff').attr('font-size', '14px').attr('font-weight', '600').text(d.data.name)

          const upBtn = g.append('g').attr('class', 'expandBtn center-expand-up')
            .attr('transform', `translate(0, ${-h / 2 - 12})`).style('cursor', 'pointer')
            .on('click', (e) => { e.stopPropagation(); vm.toggleAll('up') })
          upBtn.append('circle').attr('r', 10).attr('fill', '#fff').attr('stroke', '#d9d9d9').attr('stroke-width', 1)
          upBtn.append('text').attr('class', 'expandBtnText').attr('text-anchor', 'middle').attr('dominant-baseline', 'middle')
            .attr('fill', '#999').attr('font-size', '14px').attr('font-weight', 'bold')
            .text(vm.rootOfUp.children && vm.rootOfUp.children.length > 0 ? '−' : '+')

          const downBtn = g.append('g').attr('class', 'expandBtn center-expand-down')
            .attr('transform', `translate(0, ${h / 2 + 12})`).style('cursor', 'pointer')
            .on('click', (e) => { e.stopPropagation(); vm.toggleAll('down') })
          downBtn.append('circle').attr('r', 10).attr('fill', '#fff').attr('stroke', '#d9d9d9').attr('stroke-width', 1)
          downBtn.append('text').attr('class', 'expandBtnText').attr('text-anchor', 'middle').attr('dominant-baseline', 'middle')
            .attr('fill', '#999').attr('font-size', '14px').attr('font-weight', 'bold')
            .text(vm.rootOfDown.children && vm.rootOfDown.children.length > 0 ? '−' : '+')
          return
        }

        // ======== 非中心节点 ========
        // 事件绑定在 g 上，而不是 rect 上
        g.on('mouseenter', (e) => vm.showDetail(e, d.data))
         .on('mouseleave', () => vm.hideDetail())

        g.append('rect').attr('class', 'node-shape').attr('x', -w / 2).attr('y', -h / 2)
          .attr('width', w).attr('height', h).attr('rx', rx).attr('ry', rx).attr('fill', '#fff')
          .attr('stroke', isPerson ? '#ff8c42' : '#4a9eff').attr('stroke-width', 1)

        if (isPerson) {
          g.append('circle').attr('cx', -w / 2 + 22).attr('cy', 0).attr('r', 16).attr('fill', '#ff8c42')
          g.append('text').attr('x', -w / 2 + 22).attr('y', 1).attr('text-anchor', 'middle').attr('dominant-baseline', 'middle')
            .attr('fill', '#fff').attr('font-size', '12px').attr('font-weight', 'bold').text(d.data.name.charAt(0))
          let displayName = d.data.name.length > 6 ? d.data.name.substring(0, 5) + '...' : d.data.name
          g.append('text').attr('x', -w / 2 + 46).attr('y', -4).attr('fill', '#262626').attr('font-size', '13px').attr('font-weight', '500').text(displayName)
          if (d.data.ratio !== undefined && d.data.ratio !== null) {
            g.append('text').attr('x', -w / 2 + 46).attr('y', 14).attr('fill', '#1890ff').attr('font-size', '12px').attr('font-weight', '600').text(`${d.data.ratio}%`)
          }
        } else {
          let textY = 0
          if (d.data.tag) {
            const tagWidth = d.data.tag.length * 11 + 8
            g.append('rect').attr('x', -w / 2 + 8).attr('y', -h / 2 + 6).attr('width', tagWidth).attr('height', 16).attr('rx', 2)
              .attr('fill', '#e6f7ff').attr('stroke', '#91d5ff').attr('stroke-width', 0.5)
            g.append('text').attr('x', -w / 2 + 8 + tagWidth / 2).attr('y', -h / 2 + 17).attr('text-anchor', 'middle').attr('fill', '#1890ff').attr('font-size', '10px').text(d.data.tag)
            textY = 2
          } else { textY = -6 }
          const maxChars = 11
          let line1 = d.data.name, line2 = ''
          if (d.data.name.length > maxChars) {
            line1 = d.data.name.substring(0, maxChars)
            line2 = d.data.name.substring(maxChars, maxChars * 2)
            if (d.data.name.length > maxChars * 2) line2 += '...'
          }
          g.append('text').attr('x', 0).attr('y', textY).attr('text-anchor', 'middle').attr('fill', '#262626').attr('font-size', '12px').attr('font-weight', '500').text(line1)
          if (line2) g.append('text').attr('x', 0).attr('y', textY + 14).attr('text-anchor', 'middle').attr('fill', '#262626').attr('font-size', '12px').attr('font-weight', '500').text(line2)
          if (d.data.ratio !== undefined && d.data.ratio !== null) {
            const ratioY = line2 ? textY + 28 : textY + 16
            g.append('text').attr('x', 0).attr('y', ratioY).attr('text-anchor', 'middle').attr('fill', '#1890ff').attr('font-size', '11px').attr('font-weight', '600').text(`${d.data.ratio}%`)
          }
        }

        // 展开按钮逻辑
        const canExpandByFlag = isUp ? d.data.canExpandParent : d.data.canExpandChild
        const hasToggleableChildren = d._children || (d.children && d.children.length > 0)

        if (canExpandByFlag || hasToggleableChildren) {
          const btnY = isUp ? -h / 2 - 10 : h / 2 + 10
          // 展开显示 −，收起/有更多数据可加载显示 +
          const btnSymbol = d.children != null ? '−' : '+'
          const btnG = g.append('g').attr('class', 'expandBtn').attr('transform', `translate(0, ${btnY})`).style('cursor', 'pointer')
            .on('click', (e) => { e.stopPropagation(); vm.fetchAndExpand(d, isUp) })
          btnG.append('circle').attr('r', 9).attr('fill', '#1890ff').attr('stroke', '#fff').attr('stroke-width', 1.5)
          btnG.append('text').attr('class', 'expandBtnText').attr('text-anchor', 'middle').attr('dominant-baseline', 'middle')
            .attr('fill', '#fff').attr('font-size', '14px').attr('font-weight', 'bold')
            .text(btnSymbol)
        }
      })
    },

    async fetchAndExpand(d, isUp) {
      const nodeKey = d.data.creditCode || d.data.name

      // 如果当前节点是展开状态，则收起
      if (d.children) {
        d._children = d.children
        d.children = null
        this.update(d)
        return
      }

      // 防止重复请求
      if (this._fetchingNodes.has(nodeKey)) return
      this._fetchingNodes.add(nodeKey)

      // 构造请求参数
      const params = { ...this.reuqestData }
      if (d.data.creditCode) {
        params.stockCode = d.data.stockCode
        params.creditCode = d.data.creditCode
      }
      params.title = d.data.name
      params.type = isUp ? 1 : 2

      try {
        const res = await getEquityData(params)
        const transformed = this.transformData(res)

        let newChildrenData = []
        if (isUp) {
          newChildrenData = transformed.parents || []
          d.data.parents = newChildrenData
        } else {
          newChildrenData = transformed.childList || []
          d.data.childList = newChildrenData
        }

        d._children = null

        if (newChildrenData.length > 0) {
          const childrenAccessor = isUp ? (nd => nd.parents) : (nd => nd.childList)
          d.children = newChildrenData.map(childData => {
            const hNode = d3.hierarchy(childData, childrenAccessor)
            hNode.depth = d.depth + 1
            hNode.x0 = d.x0
            hNode.y0 = d.y0
            // 必须手动设置 parent
            hNode.parent = d
            if (hNode.children) {
              hNode._children = hNode.children
              hNode.children = null
            }
            return hNode
          })
        } else {
          d.children = null
        }

        this.update(d)
      } catch (err) {
        console.error('获取节点数据失败', err)
      } finally {
        this._fetchingNodes.delete(nodeKey)
      }
    },

    highlightLinks(nodeData) {
      if (!this.gLinks) return
      const nodeId = nodeData.id || nodeData.name
      this.gLinks.selectAll('path').each(function (d) {
        const link = d3.select(this)
        const isRelated = (d.source.data.id || d.source.data.name) === nodeId || (d.target.data.id || d.target.data.name) === nodeId
        if (isRelated) {
          link.attr('stroke', '#1890ff').attr('stroke-width', 2.5).attr('opacity', 1)
        } else {
          link.attr('stroke', '#d9d9d9').attr('stroke-width', 1).attr('opacity', 0.15)
        }
      })
    },

    restoreLinks() {
      if (!this.gLinks) return
      this.gLinks.selectAll('path').attr('stroke', '#b0c4de').attr('stroke-width', 1.5).attr('opacity', 1)
    },

    showDetail(event, d) {
      clearTimeout(this.hideCardTimer)
      clearTimeout(this.hideCenterCardTimer)
      clearTimeout(this.showCardTimer)

      const rect = event.target.getBoundingClientRect()
      const containerRect = this.$refs.container.getBoundingClientRect()
      const cardW = 300, cardH = 180
      let left = rect.left - containerRect.left + rect.width / 2 - cardW / 2
      let top = rect.top - containerRect.top - cardH - 4
      if (left < 10) left = 10
      if (left + cardW > containerRect.width - 10) left = containerRect.width - cardW - 10
      if (top < 60) top = rect.bottom - containerRect.top + 4
      const calculatedStyle = { left: `${left}px`, top: `${top}px` }

      this._pendingShowDetail = { data: d, style: calculatedStyle }

      // 优化：延迟从 1000ms 改为 300ms，提升响应速度
      this.showCardTimer = setTimeout(() => {
        if (this._pendingShowDetail && this._pendingShowDetail.data === d) {
          this.highlightLinks(d)
          this.hoverNode = {
            name: d.name, type: d.type, ratio: d.ratio,
            amount: d.amount, stockCode: d.stockCode,
            creditCode: d.creditCode, legalPerson: d.legalPerson,
            regCapital: d.regCapital,
          }
          this.centerHover = false
          this.cardStyle = calculatedStyle
        }
      }, 300)
    },

    hideDetail() {
      // 优化：给 150ms 的缓冲，避免鼠标在节点内元素间移动时误触
      this.hideCardTimer = setTimeout(() => {
        clearTimeout(this.showCardTimer)
        this._pendingShowDetail = null
        this.hoverNode = null
        this.restoreLinks()
      }, 150)
    },

    onCardEnter() { clearTimeout(this.hideCardTimer) },
    onCardLeave() {
      this.hoverNode = null
      this.restoreLinks()
    },

    showCenterDetail(event) {
      clearTimeout(this.hideCardTimer)
      clearTimeout(this.hideCenterCardTimer)
      clearTimeout(this.showCenterCardTimer)

      const rect = event.target.getBoundingClientRect()
      const containerRect = this.$refs.container.getBoundingClientRect()
      const cardW = 340, cardH = 300
      let left = rect.left - containerRect.left + rect.width + 4
      let top = rect.top - containerRect.top
      if (left + cardW > containerRect.width - 10) left = rect.left - containerRect.left - cardW - 4
      if (top < 60) top = 60
      if (top + cardH > containerRect.height - 10) top = containerRect.height - cardH - 10
      const calculatedStyle = { left: `${left}px`, top: `${top}px` }

      this._pendingShowCenter = true

      // 优化：延迟从 1000ms 改为 300ms
      this.showCenterCardTimer = setTimeout(() => {
        if (this._pendingShowCenter) {
          this.highlightLinks(this.rawData)
          this.centerHover = true
          this.hoverNode = null
          this.centerCardStyle = calculatedStyle
        }
      }, 300)
    },

    hideCenterDetail() {
      // 优化：给 150ms 的缓冲
      this.hideCenterCardTimer = setTimeout(() => {
        clearTimeout(this.showCenterCardTimer)
        this._pendingShowCenter = false
        this.centerHover = false
        this.restoreLinks()
      }, 150)
    },

    onCenterCardEnter() { clearTimeout(this.hideCenterCardTimer) },
    onCenterCardLeave() {
      this.centerHover = false
      this.restoreLinks()
    },

    toggleNode(d) {
      if (d.children) { d._children = d.children; d.children = null }
      else if (d._children) { d.children = d._children; d._children = null }
      this.update(d)
    },

    toggleAll(direction) {
      const root = direction === 'up' ? this.rootOfUp : this.rootOfDown
      if (root.children) { root._children = root.children; root.children = null }
      else if (root._children) { root.children = root._children; root._children = null }
      this.update(root)
    },

    updateAllExpandBtnSymbols() {
      const vm = this
      vm.gNodes.selectAll('.center-expand-up').each(function () {
        d3.select(this).select('text').text(vm.rootOfUp.children != null ? '−' : '+')
      })
      vm.gNodes.selectAll('.center-expand-down').each(function () {
        d3.select(this).select('text').text(vm.rootOfDown.children != null ? '−' : '+')
      })
      // 非中心节点：展开显示 −，收起/有更多数据可加载显示 +
      vm.gNodes.selectAll('.expandBtn').each(function (d) {
        const btn = d3.select(this)
        if (btn.classed('center-expand-up') || btn.classed('center-expand-down')) return
        if (d) btn.select('text').text(d.children != null ? '−' : '+')
      })
    },

    setupZoom() {
      const svg = d3.select(this.$refs.svg)
      if (!svg.node()) return
      const zoom = d3.zoom().scaleExtent([0.2, 5])
        .on('zoom', (event) => { this.translateX = event.transform.x; this.translateY = event.transform.y; this.currentZoom = event.transform.k })
      svg.call(zoom).on('dblclick.zoom', null)
    },
    handleResize() { this.initCanvas(); if (this.rawData) this.drawChart() }
  }
}
</script>

<style scoped>
.color-blue { color: #1890ff !important; }
.color-blue:hover { color: #40a9ff !important;cursor: pointer; }
.equity-chart {
  width: 100%;
  height: 100vh;
  position: relative;
  background: #f5f7fa;
  overflow: hidden;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}
.toolbar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 48px;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  z-index: 100;
}
.toolbar-left {
  display: flex;
  align-items: center;
  gap: 10px;
}
.toolbar-title {
  font-size: 15px;
  font-weight: 600;
  color: #262626;
}
.toolbar-divider {
  color: #d9d9d9;
}
.toolbar-company {
  font-size: 13px;
  color: #8c8c8c;
}
.legend-panel {
  position: absolute;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  border-radius: 6px;
  padding: 10px 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #f0f0f0;
  z-index: 100;
  display: flex;
  gap: 20px;
}
.legend-row {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #595959;
}
.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 2px;
}
.legend-dot.current {
  background: #1890ff;
}
.legend-dot.company {
  background: #fff;
  border: 1.5px solid #4a9eff;
}
.legend-dot.person {
  background: #ff8c42;
  border-radius: 50%;
}
.legend-line {
  width: 20px;
  height: 0;
  border-top: 1.5px solid #b0c4de;
}
.canvas-area {
  width: 100%;
  height: 100%;
  padding-top: 48px;
}
.main-svg {
  width: 100%;
  height: 100%;
  cursor: grab;
}
.main-svg:active {
  cursor: grabbing;
}
:deep(.node-shape) {
  transition: filter 0.2s, stroke-width 0.2s;
}
:deep(.nodeOfDownItemGroup:hover .node-shape),
:deep(.nodeOfUpItemGroup:hover .node-shape) {
  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.12));
  stroke-width: 2px !important;
}
:deep(.expandBtn:hover circle) {
  fill: #40a9ff;
}
.center-card {
  position: absolute;
  width: 340px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  border: 1px solid #f0f0f0;
  z-index: 200;
  overflow: hidden;
  pointer-events: auto;
}
.center-card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px;
  background: #fafafa;
  border-bottom: 1px solid #f0f0f0;
}
.center-logo {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  color: #1890ff;
  flex-shrink: 0;
}
.center-info {
  flex: 1;
  min-width: 0;
}
.center-name {
  font-size: 15px;
  font-weight: 600;
  color: #262626;
  margin-bottom: 4px;
}
.center-status {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 3px;
  font-size: 11px;
  background: #f6ffed;
  color: #52c41a;
  border: 1px solid #b7eb8f;
}
.center-card-body {
  padding: 12px 14px;
}
.center-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 10px;
}
.tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 3px;
  font-size: 11px;
  background: #f5f5f5;
  color: #595959;
}
.tag.blue {
  background: #e6f7ff;
  color: #1890ff;
}
.center-detail {
  border-top: 1px solid #f0f0f0;
  padding-top: 8px;
}
.detail-row {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
}
.detail-label {
  font-size: 12px;
  color: #8c8c8c;
}
.detail-value {
  font-size: 12px;
  color: #262626;
  font-weight: 500;
}
.detail-value.blue {
  color: #1890ff;
}
.hover-card {
  position: absolute;
  width: 300px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  border: 1px solid #f0f0f0;
  z-index: 200;
  overflow: hidden;
  pointer-events: auto;
}
.card-head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px;
  background: #fafafa;
  border-bottom: 1px solid #f0f0f0;
}
.card-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  color: #fff;
  flex-shrink: 0;
}
.card-avatar.person {
  background: #ff8c42;
}
.card-avatar.company {
  background: #4a9eff;
}
.card-info {
  flex: 1;
  min-width: 0;
}
.card-name {
  font-size: 14px;
  font-weight: 600;
  color: #262626;
  margin-bottom: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
.card-badge {
  display: inline-block;
  padding: 1px 6px;
  border-radius: 3px;
  font-size: 10px;
  font-weight: 500;
}
.card-badge.person {
  background: #fff2e8;
  color: #ff6b1a;
}
.card-badge.company {
  background: #e6f7ff;
  color: #1890ff;
}
.card-content {
  padding: 10px 14px;
}
.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0;
  border-bottom: 1px solid #f5f5f5;
}
.info-row:last-child {
  border-bottom: none;
}
.info-label {
  font-size: 12px;
  color: #8c8c8c;
}
.info-value {
  font-size: 12px;
  color: #262626;
  font-weight: 500;
  max-width: 160px;
  text-align: right;
  word-break: break-all;
}
.info-value.orange {
  color: #ff6b1a;
  font-weight: 600;
}
.card-fade-enter-active,
.card-fade-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}
.card-fade-enter-from,
.card-fade-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}
</style>